import { Dispatch, FC, SetStateAction } from "react";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";
import { Col, Row } from "../../BaseComponents/Flex";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { ResetLogin } from "redux/slices/LoginSlice";
import { resetOtp } from "redux/slices/OtpSlice";
import { resetServiceError } from "redux/slices/ServiceInlineError";

interface FirstPasswordChangeExitModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
  //   navigate: NavigateFunction;
  //   dispatch: any;
}

const FirstPasswordChangeExitModal: FC<FirstPasswordChangeExitModalProps> = ({
  title,
  message,
  acceptButtonText,
  rejectButtonText,
  setIsOpen,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onAcceptClick = () => {
    dispatch(ResetLogin());
    dispatch(resetOtp());
    dispatch(resetServiceError());
    setIsOpen(false);
    navigate("/");
  };

  return (
    <Modal
      info={message}
      maxWidth={450}
      setIsOpen={setIsOpen}
      title={title}
      isClosable={false}
    >
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button onClick={onAcceptClick} text={acceptButtonText} />
        </Col>
      </Row>
    </Modal>
  );
};

export default FirstPasswordChangeExitModal;
